var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomEiendommerWhite = function SvgCustomEiendommerWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "custom-eiendommer-white_svg__a",
    d: "M0 0h9v15H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-eiendommer-white_svg__b",
    d: "M5 2h2v2H5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-eiendommer-white_svg__c",
    d: "M10 8h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-eiendommer-white_svg__d",
    d: "M13 8h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-eiendommer-white_svg__e",
    d: "M5 5h2v2H5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-eiendommer-white_svg__f",
    d: "M5 8h2v2H5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-eiendommer-white_svg__g",
    d: "M2 2h2v2H2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-eiendommer-white_svg__h",
    d: "M2 5h2v2H2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "custom-eiendommer-white_svg__i",
    d: "M2 8h2v2H2z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "custom-eiendommer-white_svg__j",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 9,
    height: 15,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#custom-eiendommer-white_svg__a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "custom-eiendommer-white_svg__k",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#custom-eiendommer-white_svg__b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "custom-eiendommer-white_svg__l",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#custom-eiendommer-white_svg__c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "custom-eiendommer-white_svg__m",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#custom-eiendommer-white_svg__d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "custom-eiendommer-white_svg__n",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#custom-eiendommer-white_svg__e"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "custom-eiendommer-white_svg__o",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#custom-eiendommer-white_svg__f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "custom-eiendommer-white_svg__p",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#custom-eiendommer-white_svg__g"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "custom-eiendommer-white_svg__q",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#custom-eiendommer-white_svg__h"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "custom-eiendommer-white_svg__r",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 2,
    height: 2,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#custom-eiendommer-white_svg__i"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    mask: "url(#custom-eiendommer-white_svg__j)",
    strokeWidth: 2,
    xlinkHref: "#custom-eiendommer-white_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.5h5M16.5 6.5v8M15.5 14.5h-5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#custom-eiendommer-white_svg__k)",
    strokeWidth: 2,
    fill: "#FFF",
    xlinkHref: "#custom-eiendommer-white_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#custom-eiendommer-white_svg__l)",
    strokeWidth: 2,
    fill: "#FFF",
    xlinkHref: "#custom-eiendommer-white_svg__c"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#custom-eiendommer-white_svg__m)",
    strokeWidth: 2,
    fill: "#FFF",
    xlinkHref: "#custom-eiendommer-white_svg__d"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#custom-eiendommer-white_svg__n)",
    strokeWidth: 2,
    fill: "#FFF",
    xlinkHref: "#custom-eiendommer-white_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#custom-eiendommer-white_svg__o)",
    strokeWidth: 2,
    fill: "#FFF",
    xlinkHref: "#custom-eiendommer-white_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#custom-eiendommer-white_svg__p)",
    strokeWidth: 2,
    fill: "#FFF",
    xlinkHref: "#custom-eiendommer-white_svg__g"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#custom-eiendommer-white_svg__q)",
    strokeWidth: 2,
    fill: "#FFF",
    xlinkHref: "#custom-eiendommer-white_svg__h"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#custom-eiendommer-white_svg__r)",
    strokeWidth: 2,
    fill: "#FFF",
    xlinkHref: "#custom-eiendommer-white_svg__i"
  }))));
};
export { SvgCustomEiendommerWhite as ReactComponent };
export default "data:image/svg+xml;base64,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";